// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const removeFilteredFromHighlight = visiblePathIds => (dispatch, getState) => (
  getState()
    .interferenceAnalysis
    .get('highlightedPathIds')
    .filter(d => visiblePathIds.includes(d))
)

export default removeFilteredFromHighlight
